import { useMutation } from "@tanstack/react-query";
import { consolidationContract } from "@common/contracts/consolidation.contract";
import {
    ConsolidationGroupResponse,
    UpdateConsolidationGroupConfigBody,
} from "@common/schemas/domains/accounting/consolidation.schema";
import { getBackendAPIClient } from "@lib/backendAPIClient";
import { queryClient } from "queryClient";
import { invalidateConsolidationGroupMutations } from "./consolidationCache.helpers";

const consolidationClient = getBackendAPIClient(consolidationContract);

interface UpdateGroupConfigVariables {
    groupId: string;
    body: UpdateConsolidationGroupConfigBody;
}

export function useUpdateGroupConfigMutation(workspaceId: string) {
    return useMutation({
        mutationFn: async ({
            groupId,
            body,
        }: UpdateGroupConfigVariables): Promise<ConsolidationGroupResponse> => {
            const result = await consolidationClient.updateGroupConfig({
                params: { workspaceId, id: groupId },
                body,
            });
            if (result.status !== 200) {
                throw result;
            }
            return result.body.group;
        },
        onSuccess: () => {
            invalidateConsolidationGroupMutations(queryClient);
        },
    });
}
